const subjectList = {
    en: [
        "Please choose..",
        "I'm having offline problem",
        "I can not see Staff App requests",
        "Having problem with another user",
        "I'm having a notification problem",
        "I'm having a Staff App role problem",
        "I'm having problems with the booking screen",
        "I'm having Staff App slowness problem",
        "Others"
    ],
    tr: [
        "Lütfen seçim yapınız..",
        "Offline sorunu yaşıyorum",
        "Request görüntüleme sorunu yaşıyorum",
        "Başka Kullanıcı hakkında sorun yaşanıyor",
        "Bildirim sorunu yaşıyorum",
        "Staff App rol problemi yaşıyorum",
        "Booking ekranında sorun yaşıyorum",
        "Staff App yavaşlık problemi yaşıyorum",
        "Diğer"
    ],
    ar: [
        "يرجى تحديد اختيارك",
        "أواجه مشكلة في الاتصال بالإنترنت"
        , "لا أستطيع رؤية طلبات Staff App"
        , "لديك مشكلة مع مستخدم آخر"
        , "لدي مشكلة مع وسائل الإعلام"
        , "أواجه مشكلة مع دور Staff App"
        , "أواجه مشاكل في شاشة الحجز"
        , "أواجه مشكلة بطيئة في Staff App"
        , "آحرون"
    ]
};

export default subjectList;
